import React from 'react';
import { BrowserRouter as Router,Switch,Route } from 'react-router-dom';
import Navbar from './component/Navbar';
import Home from '../src/pages/Home'
import Earphone from '../src/pages/Earphone'
import Headphone from '../src/pages/Headphone'
import Speaker from '../src/pages/Speaker'
import Cart from '../src/pages/Cart'
import './index.scss';

function App() {
  return (
    <Router >
      <Navbar/>
      <Switch>
        <Route exact path='/'>
          <Home/>
        </Route>
        <Route path='/headphone'>
          <Headphone/>
        </Route>
        <Route path='/earphone'>
          <Earphone/>
        </Route>
        <Route path='/speaker'>
          <Speaker/>
        </Route>
        <Route path='/cart'>
          <Cart/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
